import { FormTexts } from '../../../language/Texts'
import { ComponentType } from '../../../models/componentType.enum'

interface CheckboxProps {
    isPrivacyPolicyAccepted: boolean,
    setIsPrivacyPolicyAccepted: (isAccepted: boolean) => void,
    isAdvertisingAgreed: boolean,
    setIsAdvertisingAgreed: (isAccepted: boolean) => void
    type?: ComponentType
}

function FooterCheckBox({
    isPrivacyPolicyAccepted, setIsPrivacyPolicyAccepted,
    isAdvertisingAgreed, setIsAdvertisingAgreed,
    type
}: CheckboxProps) {

    const handleClick = () => {
        const mailConfig = `mailto:${'datenschutz@gemue.de'}?subject=${'Datenschutz'}`
        window.open(mailConfig)
    }

    return (
         <div className="privacy_policy">
            <div className='checkbox_group'>
                <input
                    id="checkbox_advertising"
                    className={`checkbox_input ${type === ComponentType.GEMUE_EXTERNAL ? 'gemue_checkbox_input' : ''}`}
                    checked={isAdvertisingAgreed}
                    onChange={() => setIsAdvertisingAgreed(!isAdvertisingAgreed)}
                    type="checkbox" />
                <label className='checkbox_label' htmlFor="checkbox_advertising">
                    {FormTexts.voluntaryText_1}&nbsp;
                    <span className='email_redirect' onClick={() => handleClick()}>
                        datenschutz@gemue.de
                    </span>
                    {FormTexts.voluntaryText_2}
                </label>
            </div>
            <div className='checkbox_group'>
                <input
                    id="checkbox_privacy_policy"
                    className={`checkbox_input ${type === ComponentType.GEMUE_EXTERNAL ? 'gemue_checkbox_input' : ''}`}
                    checked={isPrivacyPolicyAccepted}
                    onChange={() => setIsPrivacyPolicyAccepted(!isPrivacyPolicyAccepted)}
                    type="checkbox" />
                <label className='checkbox_label' htmlFor="checkbox_privacy_policy">
                     {FormTexts.dataProtectionText1}&nbsp;
                    <a
                        className='footer_link'
                        href={FormTexts.dataProtectionUrl}
                        target='_blank'
                        rel="noopener noreferrer">
                        {FormTexts.dataProtectionText2}
                    </a>
                </label>
            </div>
        </div>
    )
}

export default FooterCheckBox
